import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../safreeimg/loader.gif'
import leftarrow from '../../../safreeimg/left-arrow.png'

const OrgMemberDetails = () => {
  const [organisations, setOrganisations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const rowsPerPage = 10;
const navigate = useNavigate(); 
  const fetchOrganisations = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');
      if (!token) {
        setError('No token found');
        setLoading(false);
        return;
      }

      const response = await axios.get('https://api.safree.org/api-v2022/superAdmin/auth/v1/allOrganizations', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOrganisations(response.data.data); 
    } catch (err) {
      setError('Error fetching data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganisations();
  }, []);

  const totalPages = Math.ceil(organisations.length / rowsPerPage);
  const currentRows = organisations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;

  if (error) return <div>Error: {error}</div>;
  const handleBackClick = () => {
    navigate(-1);  
  };
  return (
    <div className="container user-management">
      {/* Header Section */}
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading"> <img  onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> Organization Member Details</p>
        </div>
      </div>

      <div className="content-wrapper">
        {/* Table Section */}
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Name</th>
                <th>Email ID</th>
                <th>Phone No</th>
                <th>Image</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((organisation, index) => (
                <tr key={organisation._id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{organisation.name}</td>
                  <td>{organisation.email}</td>
                  <td>{organisation.phoneNumber}</td>
                  <td>
                    {organisation.logo ? (
                      <img
                        src={organisation.logo}
                        alt="Organisation Logo"
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                      />
                    ) : (
                      <span>No Logo Available</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Section */}
          <div className="pagination-container">
            <button
              className="pagination-btn"
              onClick={() => handlePageChange('prev')}
              disabled={currentPage === 1}
            >
              &laquo; Prev
            </button>
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
            <button
              className="pagination-btn"
              onClick={() => handlePageChange('next')}
              disabled={currentPage === totalPages}
            >
              Next &raquo;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgMemberDetails;
